import { render, staticRenderFns } from "./selectedInbox.vue?vue&type=template&id=c47814b6&scoped=true"
import script from "./selectedInbox.vue?vue&type=script&lang=js"
export * from "./selectedInbox.vue?vue&type=script&lang=js"
import style0 from "./selectedInbox.vue?vue&type=style&index=0&id=c47814b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47814b6",
  null
  
)

export default component.exports